import { Component } from '@angular/core';

@Component({
  selector: 'app-footer',
  template: `
    <footer class="foot">
      <span class="cpy"
        >&#169;{{
          since.getFullYear() === today.getFullYear()
            ? today.getFullYear()
            : since.getFullYear() + '-' + today.getFullYear()
        }}
        &#183; Emplay .Inc &#183; All Rights Reserved</span
      >
      <span class="links">
        <a href="https://www.emplay.net" target="_blank">
          Emplay INC
          <svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M15 3h6v6M10 14 21 3M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"/></svg>
        </a>
        <a
          href="https://www.linkedin.com/company/emplay-inc-/mycompany/"
          target="_blank"
        >
          <svg viewBox="0 0 24 24" width="15" height="15" fill="currentColor"><path d="M4.98 3.5A2.5 2.5 0 1 1 0 3.5a2.5 2.5 0 0 1 4.98 0ZM0 8h5v16H0V8Zm7.5 0h4.8v2.2h.07c.67-1.2 2.3-2.46 4.73-2.46C22 7.74 24 10 24 14.4V24h-5v-8.5c0-2-.04-4.6-2.8-4.6-2.8 0-3.24 2.2-3.24 4.46V24h-5V8Z"/></svg>
          LinkedIn
        </a>
      </span>
    </footer>
  `,
  styleUrls: ['./footer.component.scss'],
})
export class FooterComponent {
  since = new Date('01/09/2022');
  today = new Date(Date.now());

  openReportFormHandler(): void {
    console.debug('opening the issue form!');
  }
}
